import { BRANDING_TOKENS, type ColorKey } from './tokens'

const STYLE_ID = 'vt-branding'

// Baut/aktualisiert ein <style id="vt-branding"> im <head> mit einer
// `.vitals{ … }`-Regel, die ausschließlich die GESETZTEN Branding-Tokens als
// CSS-Custom-Properties enthält. Gleiche Spezifität wie der Basis-`.vitals{}`-
// Block in vitals.css, aber später in der Kaskade ⇒ überschreibt die Defaults.
// Leere/null Werte ⇒ keine Zeile ⇒ CSS-Default bleibt erhalten. Greift damit
// einheitlich auf JEDEN `.vitals`-Container (pre-/post-auth, Light/Dark).
// Idempotent: mehrfaches Aufrufen ersetzt den Inhalt, dupliziert das Element nicht.
export function injectBrandingStyle(
  colors: Partial<Record<ColorKey, string | null>>,
): void {
  const decls = (Object.keys(BRANDING_TOKENS) as ColorKey[])
    .map((key) => {
      const value = colors[key]
      if (value == null || value === '') return null
      return `${BRANDING_TOKENS[key]}:${value}`
    })
    .filter((line): line is string => line !== null)

  let el = document.getElementById(STYLE_ID) as HTMLStyleElement | null
  if (!el) {
    el = document.createElement('style')
    el.id = STYLE_ID
    document.head.appendChild(el)
  }
  el.textContent = `.vitals{${decls.join(';')}${decls.length ? ';' : ''}}`
}
